import { Flex } from '@chakra-ui/react';
import { SupplierListItem } from '@texas/api/endpoints/suppliersApi';
import { AngularNavLink } from '../shared/AngularNavLink';

interface SupplierNameCellProps {
  supplier: SupplierListItem;
}

export function SupplierNameCell({ supplier }: SupplierNameCellProps) {
  return (
    <Flex direction="column" flex={1} gap="2px" minW={0} w="full">
      <AngularNavLink
        display="block"
        navobj={{ supplierId: supplier.id }}
        overflowWrap="anywhere"
        to="supplier"
        whiteSpace="normal"
      >
        {supplier.name}
      </AngularNavLink>
    </Flex>
  );
}
